export function initFooterColumnLinks() {
	const columns = document.querySelectorAll('.pro-footer-column-links');
	if (!columns.length) return;

	columns.forEach((column) => {
		const title = column.querySelector('.pro-footer-column-links__title');
		if (!title) return;
		title.addEventListener('click', (event) => {
			const target = event.target;
			target.parentElement.classList.toggle('opened');
		});
	});
}


